/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useState } from "react";
import { Get } from "../Utils/Helpers";
import { useLoginContext } from "./LoginContext";

interface HojaTecnica {
	producto: string;
	descripcion: string;
	archivo: string;
}

interface IHojasTecnicasContext {
	hojasTecnicas: HojaTecnica[];
	setHojasTecnicas: React.Dispatch<React.SetStateAction<HojaTecnica[]>>;
}

export const HojasTecnicasContext = createContext({} as IHojasTecnicasContext);
export const useHojasTecnicasContext = () => useContext(HojasTecnicasContext);

const Provider = ({ children }) => {
	const { loggedIn, cuil } = useLoginContext();
	const [hojasTecnicas, setHojasTecnicas] = useState([] as HojaTecnica[]);

	useEffect(() => {
		let disposed = false;

		if (!loggedIn) return;

		(async () => {
			if (disposed) return;

			const _hojasTecnicas = await Get(`/HojasTecnicas/${cuil}`);

			setHojasTecnicas(_hojasTecnicas.resultados as HojaTecnica[]);
		})();

		return () => {
			disposed = true;
		};
	}, [loggedIn]);

	const value = {
		hojasTecnicas,
		setHojasTecnicas,
	};

	return <HojasTecnicasContext.Provider value={value}>{children}</HojasTecnicasContext.Provider>;
};

const obj = {
	Provider,
	Consumer: HojasTecnicasContext.Consumer,
};

export default obj;
